import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { connect } from "react-redux";
import { actions } from "../../../redux/actions/alert";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 600,
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
  snackBar: {
    "&& .MuiAlert-root": {
      width: 800,
      fontWeight: 400,
      fontSize: 16,
      padding: theme.spacing(1),
    },
  },
}));

/**
 *
 * params
 * @message the message to show in the alert
 *
 * @severity
 * error color RED
 * warning color YELLOW
 * info color BLUE
 * success color GREEN
 *
 * @time
 * message duration
 */
const MessageAlert = ({ message, time, severity, addAlert }) => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    addAlert({ showAlert: false });
  };
  return (
    <div className={classes.root}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        className={classes.snackBar}
        open={open}
        autoHideDuration={time}
        onClose={handleClose}
      >
        <Alert
          severity={severity}
          action={[
            <IconButton key="close" onClick={handleClose}>
              <CloseIcon />
            </IconButton>,
          ]}
        >
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const dispatch = {
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(MessageAlert);
